/* eslint-disable react/prop-types */
import { useEffect, useMemo, useState } from "react";
import { Ring } from "@uiball/loaders";

import { colors, strCode } from "../../consts";
import { t } from "../../services";
import { useFocusOnInput } from "../../hooks";

import {
  EditButtonsGroup,
  FlexContainers,
  GradientLoader,
  IconButton,
  Input,
  SVG,
  TextOverflowWrapper,
  WrapperContainer
} from "../../components";
import { CellWrapper } from "../../components/Table/styled";

export const GroupsTableColumns = [
  {
    Header: strCode.NAME_TITLE,
    accessor: "name",
    Cell: ({
      cell,
      isLoading,
      searchedText,
      callbackFn1: getEditingGroup,
      callbackFn2: onEditCancel,
      callbackFn3: onEditSave,
      callbackFn4: onDelete,
      callbackFn5: onSetEditingGroup,
      callbackFn6: getLoadingChanges
    }) => {
      const [inputValue, setInputValue] = useState("");
      const [groupToDelete, setGroupToDelete] = useState(null);

      const group = cell.row.original;
      const editingGroup = getEditingGroup();
      const loadingChanges = getLoadingChanges();

      const isEditing = useMemo(() => {
        return !!editingGroup && editingGroup.name === group.name;
      }, [editingGroup, cell]);

      const isSaving = useMemo(() => {
        return (
          loadingChanges &&
          (editingGroup?.id === group?.id || (!editingGroup?.id && groupToDelete?.id === group?.id))
        );
      }, [editingGroup, group, loadingChanges, groupToDelete]);

      useEffect(() => {
        if (isEditing) {
          setInputValue(getEditingGroup().name);
        }
      }, [isEditing]);

      const inputRef = useFocusOnInput(isEditing);

      return (
        <CellWrapper width="100%">
          <WrapperContainer Container={FlexContainers.FlexRowBetween} width="100%">
            <WrapperContainer width="100%">
              {isEditing ? (
                <WrapperContainer maxWidth={300} width="100%">
                  <Input
                    id={group.name + "-input"}
                    isSmall
                    value={inputValue}
                    placeholder={strCode.GROUP_PlACEHOLDER}
                    setValue={(value) => setInputValue(value)}
                    disabled={isLoading}
                    innerRef={inputRef}
                  />
                </WrapperContainer>
              ) : (
                <TextOverflowWrapper highlightedText={searchedText}>
                  {isLoading ? (
                    <GradientLoader width={300} height={24} animationDuration={40} />
                  ) : (
                    group.name
                  )}
                </TextOverflowWrapper>
              )}
            </WrapperContainer>

            {!isLoading && (
              <WrapperContainer Container={FlexContainers.FlexRowEnd} width="100%" gap={24}>
                {!isEditing && !isSaving && (
                  <IconButton
                    onClick={() => {
                      setGroupToDelete(group);
                      onDelete(group.name);
                    }}
                    tooltipLabel={t(strCode.DELETE_BTN)}
                    disabled={loadingChanges}>
                    <SVG.DeleteIcon />
                  </IconButton>
                )}

                <WrapperContainer>
                  {isSaving ? (
                    <Ring size={32} lineWeight={5} speed={2} color={colors.RAISIN_50} />
                  ) : (
                    <EditButtonsGroup
                      handleCancel={onEditCancel}
                      handleAccept={() => onEditSave(inputValue)}
                      handleEdit={() => onSetEditingGroup(group)}
                      isEdit={!isEditing}
                      disableEdit={loadingChanges}
                      disableAccept={!inputValue.length || editingGroup?.name === inputValue}
                    />
                  )}
                </WrapperContainer>
              </WrapperContainer>
            )}
          </WrapperContainer>
        </CellWrapper>
      );
    }
  }
];
